import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initLanguage } from './i18n/I18n';
import { scheduleRenewal, takeSignInReturn } from './state/webAuth';
import { App } from './ui/App';
import './ui/app.css';
import './ui/agent.css';
// The editor's stylesheets load here, not from the components, so node tests can import the components.
import './ui/collaboration/chat.css';
import './ui/collaboration/share.css';
import './ui/collaboration/participant.css';

// The language is settled before anything renders: the browser's, or the one `?lang=` chose.
initLanguage();

// The site's return is read before App's first render, which rewrites the address and would drop the token.
const signInReturn = location.pathname === '/auth/done' ? takeSignInReturn(location.hash) : null;
const renewalFrame = !!signInReturn && window.parent !== window;

if (!renewalFrame) {
  if (signInReturn) history.replaceState(null, '', ('back' in signInReturn && signInReturn.back) || '/?section=home');
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
  scheduleRenewal();
}
